import {ValidateFunc} from '@/project'

const isCorpRNum: ValidateFunc = (number: any): boolean => {
  if(number.length !== 13) {
    return false
  }
  const arrRegNo = number.split('').map((v) => parseInt(v, 10))
  const arrWt: number[] = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2]
  let iSumRegNo = 0
  for(let i = 0; i < arrWt.length; i += 1) {
    iSumRegNo += arrRegNo[i] * arrWt[i]
  }
  const iCheckDigit = (10 - iSumRegNo % 10) % 10
  return iCheckDigit === arrRegNo[12]
}

export default isCorpRNum
